import { render, staticRenderFns } from "./VizRuota.vue?vue&type=template&id=320c73a4&scoped=true&"
import script from "./VizRuota.vue?vue&type=script&lang=js&"
export * from "./VizRuota.vue?vue&type=script&lang=js&"
import style0 from "./VizRuota.vue?vue&type=style&index=0&id=320c73a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c73a4",
  null
  
)

component.options.__file = "VizRuota.vue"
export default component.exports